import React from 'react';
import { Bell, Settings, User, HelpCircle, Plus } from 'lucide-react';
export function Header() {
  return <header className="bg-white border-b border-gray-200" data-id="element-2">
      <div className="max-w-7xl mx-auto px-6" data-id="element-3">
        <div className="flex items-center justify-between h-16" data-id="element-4">
          {/* Logo and Navigation */}
          <div className="flex items-center space-x-8" data-id="element-5">
            <div className="flex items-center space-x-3" data-id="element-6">
              <div className="w-8 h-8 bg-purple-600 rounded-lg flex items-center justify-center" data-id="element-7">
                <span className="text-white font-bold text-sm" data-id="element-8">TS</span>
              </div>
              <span className="text-xl font-semibold text-gray-900" data-id="element-9">
                TypeShift
              </span>
            </div>
            <nav className="hidden md:flex items-center space-x-6" data-id="element-10">
              <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-11">
                Products
              </a>
              <a href="#" className="text-purple-600 font-medium" data-id="element-12">
                Claims
              </a>
              <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-13">
                Reports
              </a>
            </nav>
          </div>
          {/* Actions */}
          <div className="flex items-center space-x-4" data-id="element-14">
            <button className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 flex items-center space-x-2" data-id="element-15">
              <Plus className="w-4 h-4" data-id="element-16" />
              <span data-id="element-17">Create New</span>
            </button>
            <div className="flex items-center space-x-2" data-id="element-18">
              <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg" data-id="element-19">
                <HelpCircle className="w-5 h-5" data-id="element-20" />
              </button>
              <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg" data-id="element-21">
                <Bell className="w-5 h-5" data-id="element-22" />
              </button>
              <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg" data-id="element-23">
                <Settings className="w-5 h-5" data-id="element-24" />
              </button>
              <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg" data-id="element-25">
                <User className="w-5 h-5" data-id="element-26" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>;
}